export class JobsListing extends HTMLElement {
    static EVENTS = {
        INVIEW: 'inview'
    };

    private $list: HTMLElement;
    private $items: NodeListOf<HTMLElement>;
    private $sortButtons: NodeListOf<HTMLElement>;

    constructor() {
        super();
        // UI
        this.$list = this.querySelector('[data-list]') as HTMLElement;
        this.$items = this.querySelectorAll('[data-item]') as NodeListOf<HTMLElement>;
        this.$sortButtons = this.querySelectorAll('[data-sort]') as NodeListOf<HTMLElement>;

        // Binding
        this.onSortClick = this.onSortClick.bind(this);
    }

    ///////////////
    // Lifecycle
    ///////////////
    connectedCallback() {
        this.bindEvents();
    }

    disconnectedCallback() {
        this.unbindEvents();
    }

    ///////////////
    // Events
    ///////////////
    bindEvents() {
        this.$sortButtons.forEach(($button) => {
            $button.addEventListener('click', this.onSortClick);
        });
    }

    unbindEvents() {
        this.$sortButtons.forEach(($button) => {
            $button.removeEventListener('click', this.onSortClick);
        });
    }

    onSortClick(e: MouseEvent) {
        const $target: any = e.target;
        const slug = $target.dataset.slug;

        // Error
        if (slug == null) {
            console.warn('Error: no slug provided');
            return;
        }

        // Get current order
        const currentOrder = parseInt($target.dataset.order);

        // Compute new order
        const newOrder = currentOrder == 0 ? 1 : -1 * currentOrder;

        // Sort items
        this.sortItems(slug, newOrder);
        // Update order attribute
        $target.dataset.order = newOrder;
    }

    sortItems(slug: string, order: number) {
        const sortedItems = Array.from(this.$items).sort((a, b) => {
            if (a.dataset[slug] && b.dataset[slug]) {
                if (a.dataset[slug] < b.dataset[slug]) {
                    return order * -1;
                } else if (a.dataset[slug] > b.dataset[slug]) {
                    return order;
                }
            }
            return 0;
        });

        // Append sorted items to list
        for (let item of sortedItems) {
            this.$list.appendChild(item);
        }
    }
}
